import axios from 'axios'
import globalVariable from "@/api/global_variable";
// create an axios instance
const service = axios.create({
    baseURL: globalVariable.base_url, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 60000, // request timeout
    headers: {
        'Content-Type': 'application/json',
    },
    // 请求预处理函数 可以把你传的param进行处理
    // transformRequest: [
    //     data => {
    //         // data 就是你post请求传的值
    //         // 一下主要是吧数据拼接成 类似get格式
    //         let params = ''
    //         for (var index in data) {
    //             params += index + '=' + data[index] + '&'
    //         }
    //         return params
    //     }]
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        // console.log("token=" + store.state.token);
        // config.headers.Authorization = store.state.token;
        return config
    },
    error => {
        // do something with request error
        // console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        return res
    },
    error => {
        // console.log('err' + error) // for debug
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        // return Promise.reject(error)
    }
)

export default service
